import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import Seo from '../components/Seo';

const NotFoundPage = () => (
  <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-slate-50" data-testid="not-found-page">
    <Seo title="Page not found | A Quality Handyman LLC" description="The page you requested does not exist." noindex />
    <p className="text-sm font-semibold text-brand-teal mb-2">404</p>
    <h1 className="text-4xl font-bold text-slate-900 mb-3">Page not found</h1>
    <p className="text-slate-600 mb-6 max-w-md">That link doesn't exist or has moved. Here are some helpful places to go instead.</p>
    <div className="flex flex-wrap justify-center gap-3">
      <Button asChild className="bg-brand-teal hover:bg-brand-teal/90 text-white"><Link to="/">Home</Link></Button>
      <Button asChild variant="outline"><Link to="/estimate">Instant Estimate</Link></Button>
      <Button asChild variant="outline"><Link to="/gallery">Project Gallery</Link></Button>
      <Button asChild variant="outline"><a href="tel:+15052197816">(505) 219-7816</a></Button>
    </div>
  </div>
);

export default NotFoundPage;
